// Define ws_board constants

module.exports = {
  BOARD_TYPE_PRIVATE: 0,
  BOARD_TYPE_SHARED: 1,
  BOARD_TYPE_ORG: 2,
  WS_BOARD_AI_NEW: 'WS_BOARD_AI_NEW',
  WS_BOARD_AI_UPDATE: 'WS_BOARD_AI_UPDATE',
  WS_BOARD_AI_STATE: 'WS_BOARD_AI_STATE',
  WS_BOARD_AI_RAG: 'WS_BOARD_AI_RAG',
  WS_BOARD_AI_PRIORITY: 'WS_BOARD_AI_PRIORITY',
  WS_BOARD_AI_EFFORT: 'WS_BOARD_AI_EFFORT',
  WS_BOARD_AI_OWNER: 'WS_BOARD_AI_OWNER',
  WS_BOARD_AI_START_DATE: 'WS_BOARD_AI_START_DATE',
  WS_BOARD_AI_END_DATE: 'WS_BOARD_AI_END_DATE',
  WS_BOARD_VIEW_AI_PANE: 'WS_BOARD_VIEW_AI_PANE',
  WS_BOARD_VIEW_AI_PANE_ATTR_COUNT: 'WS_BOARD_VIEW_AI_PANE_ATTR_COUNT',
  WS_BOARD_VIEW_AI_COUNT_UPDATE: 'WS_BOARD_VIEW_AI_COUNT_UPDATE',
  WS_BOARD_AI_DESC_CHANGE: 'WS_BOARD_AI_DESC_CHANGE',
  WS_BOARD_AI_NOTES_CHANGE: 'WS_BOARD_AI_NOTES_CHANGE',
  WS_BOARD_MENTION_USER_DATA: 'WS_BOARD_MENTION_USER_DATA',
  WS_BOARD_CLOSE_AI_PANE: 'WS_BOARD_CLOSE_AI_PANE',
  WS_BOARD_AI_DELETE: 'WS_BOARD_AI_DELETE',
  WS_BOARD_UPDATE_FILTERS: 'WS_BOARD_UPDATE_FILTERS',
  WS_BOARD_COLUMN_UPDATE: 'WS_BOARD_COLUMN_UPDATE',
  WS_BOARD_COLUMN_DELETE: 'WS_BOARD_COLUMN_DELETE',
  WS_BOARD_ADD_NEW_COLUMN: 'WS_BOARD_ADD_NEW_COLUMN',
  WS_BOARD_TIMELINE_MEMBER_HIGHLIGHTED: 'WS_BOARD_TIMELINE_MEMBER_HIGHLIGHTED',
  WS_BOARD_TIMELINE_DATE_CHANGES: 'WS_BOARD_TIMELINE_DATE_CHANGES',
  WS_BOARD_COLUMN_SORT: 'WS_BOARD_COLUMN_SORT',
  WS_BOARD_COLUMN_REORDER: 'WS_BOARD_COLUMN_REORDER',
  WS_BOARD_COLUMN_HEADING_SORT: 'WS_BOARD_COLUMN_HEADING_SORT',
  WS_BOARD_AI_PARENT_UPDATE: 'WS_BOARD_AI_PARENT_UPDATE',
  WS_BOARD_COL_COLOR_CHANGE: 'WS_BOARD_COL_COLOR_CHANGE',
  WS_BOARD_UPDATE_S3DATA: 'WS_BOARD_UPDATE_S3DATA',
  BOARD_FREETEXT_ADD: 'BOARD_FREETEXT_ADD',
  BOARD_VIEW_ACTIVITY: 1,
  BOARD_VIEW_SHARED: 2,
  BOARD_DATATYPE_ACTIONS: 1,
  BOARD_DATATYPE_WORKSTREAMS: 2,
  BOARD_DATATYPE_PEOPLE: 3,
  BOARD_DATATYPE_FREETEXT: 4,
  BOARD_UPDATE_SHARED_MEMBERS: 'BOARD_UPDATE_SHARED_MEMBERS',
  BOARD_UPDATE_BOARD_DATA: 'BOARD_UPDATE_BOARD_DATA',
  BOARD_ADD_NEW_ITEMS_IN_COLUMN: 'BOARD_ADD_NEW_ITEMS_IN_COLUMN',
  BOARD_DELETE_ITEM_IN_COLUMN: 'BOARD_DELETE_ITEM_IN_COLUMN',
  BOARD_UPDATE_ITEM_IN_COLUMN: 'BOARD_UPDATE_ITEM_IN_COLUMN',
  BOARD_UPDATE_BOARD_THEMES: 'BOARD_UPDATE_BOARD_THEMES',
  BOARD_WS_DATA_UPDATE: 'BOARD_WS_DATA_UPDATE',
  BOARD_FREETEXT_UPDATE: 'BOARD_FREETEXT_UPDATE',
  BOARD_AUTOMATION_UPDATE: 'BOARD_AUTOMATION_UPDATE',
  BOARD_AUTOMATION_COL_UPDATE: 'BOARD_AUTOMATION_COL_UPDATE',
  BOARD_UPDATE_USER_PERM: 'BOARD_UPDATE_USER_PERM',
  OBJECT_TYPE_BOARD: 'board',

  WS_BOARD_ADD_TAG: 'WS_BOARD_ADD_TAG',
  WS_BOARD_REMOVE_TAG: 'WS_BOARD_REMOVE_TAG',
  WS_BOARD_UPDATE_COL_VAL: 'WS_BOARD_UPDATE_COL_VAL',

  STATE_DONE: 0,
  STATE_DOING: 1,
  STATE_NEXT: 2,
  STATE_REDFLAG: 3,
  STATE_PAUSE: 4,


  RAG_GREEN: 0,
  RAG_AMBER: 1,
  RAG_RED: 2,

  PRIORITY_LOW: 3,
  PRIORITY_MED: 2,
  PRIORITY_HIGH: 1,

  STATE_0: 'DONE',
  STATE_1: 'DOING',
  STATE_2: 'NEXT',
  STATE_3: 'REDFLAG',
  STATE_4: 'PAUSE',

  RAG_0: 'GREEN',
  RAG_1: 'AMBER',
  RAG_2: 'RED',

  PRIORITY_3: 'LOW',
  PRIORITY_2: 'MED',
  PRIORITY_1: 'HIGH',

  AI_DATE_SETTING_NONE: 1,
  AI_DATE_SETTING_CURRENT: 2,
};
